import { sanitizeString } from "./sanitizeString";

/**
 * Deeply sanitizes object/array payloads by cleaning every string value.
 * Returns a new structure and never mutates input references.
 *
 * @param {*} value
 * @returns {*}
 */
export function sanitizeObject(value) {
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeObject(item));
  }

  if (value && typeof value === "object") {
    const out = {};
    Object.keys(value).forEach((key) => {
      out[key] = sanitizeObject(value[key]);
    });
    return out;
  }

  return sanitizeString(value);
}
